/* wa-mobile-collection.js
 * Mobile-only grid view for the Algolia-rendered collection pages.
 *
 * instant_search.js keeps rendering the product table exactly as before. After
 * every render this script reads that table (titles, links, price cells) plus
 * the hits it was rendered from (search.helper.lastResults, for the images) and
 * builds card markup next to the table. CSS decides which of the two is shown
 * on mobile. No Algolia query, filter or facet is touched.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'waCollView';
  var PLACEHOLDER = 'https://cdn.shopify.com/s/files/1/0663/2649/5289/files/Frame_6466.png?v=1748520880';

  var main = document.querySelector('.collection-main');
  var container = document.querySelector('.algolia-fil-products');
  if (!main || !container) return;

  if (document.querySelector('.wa-sticky-bar')) {
    document.body.classList.add('wa-has-sticky-bar');
  }

  /* ---- Grid / list toggle (grid is the default) ------------------------- */
  function storedView() {
    var v = null;
    try { v = sessionStorage.getItem(STORAGE_KEY); } catch (e) { /* storage blocked */ }
    return v === 'list' ? 'list' : 'grid';
  }
  function setView(view) {
    main.classList.toggle('wa-view-grid', view === 'grid');
    main.classList.toggle('wa-view-list', view === 'list');
    document.querySelectorAll('.wa-view-toggle__btn').forEach(function (btn) {
      var on = btn.getAttribute('data-view') === view;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    try { sessionStorage.setItem(STORAGE_KEY, view); } catch (e) { /* storage blocked */ }
  }
  document.querySelectorAll('.wa-view-toggle__btn').forEach(function (btn) {
    btn.addEventListener('click', function () { setView(btn.getAttribute('data-view')); });
  });
  setView(storedView());

  /* ---- Collection description: 5 lines + See more (mobile only) ---------- */
  (function descriptionClamp() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wa-desc-toggle';
    btn.textContent = 'See more';
    btn.hidden = true;
    desc.parentNode.insertBefore(btn, desc.nextSibling);

    var expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      desc.classList.toggle('wa-desc-clamped', !expanded);
      btn.textContent = expanded ? 'See less' : 'See more';
    });

    function evaluate() {
      if (window.innerWidth > 749) {
        desc.classList.remove('wa-desc-clamped');
        btn.hidden = true;
        return;
      }
      if (expanded) {
        btn.hidden = false;
        return;
      }
      desc.classList.add('wa-desc-clamped');
      // Only offer the toggle when the copy is actually longer than 5 lines.
      btn.hidden = desc.scrollHeight <= desc.clientHeight + 1;
    }

    evaluate();
    window.addEventListener('resize', evaluate);
  })();

  /* ---- Helpers ----------------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function handleFromHref(href) {
    var path = (href || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return decodeURIComponent(path.substring(path.lastIndexOf('/') + 1));
  }
  function imageUrl(url, width) {
    if (!url) return PLACEHOLDER;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function quoteHref(productTitle) {
    var bar = document.querySelector('.wa-sticky-bar__quote');
    var base = bar ? bar.getAttribute('href') : '/pages/quote-page?source=collection';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'product_name=' + encodeURIComponent(productTitle);
  }

  /* ---- One card from one rendered table row ------------------------------ */
  function cardHTML(row, hitsByHandle, large) {
    var link = row.querySelector('a.prpduct-title');
    if (!link) return '';
    var href = link.getAttribute('href') || '#';
    var hit = hitsByHandle[handleFromHref(href)];
    var title = (hit && hit.title) ? hit.title : link.textContent.replace(/\s+/g, ' ').trim();
    var width = large ? 800 : 400;
    var img = imageUrl(hit && hit.image, width);
    var priceEl = row.querySelector('.td-price .product-price');
    var priceHTML = priceEl ? priceEl.outerHTML : '';
    var noPrice = !!(priceEl && priceEl.classList.contains('no-price'));

    var action = '';
    if (large) {
      action = noPrice
        ? '<a class="wa-card__btn wa-card__btn--quote" href="' + esc(quoteHref(title)) + '">Get a Quote</a>'
        : '<a class="wa-card__btn wa-card__btn--view" href="' + esc(href) + '">View Product</a>';
    }

    return '<div class="wa-card' + (large ? ' wa-card--large' : '') +
      (noPrice ? ' wa-card--noprice' : '') + '">' +
      '<a class="wa-card__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' +
        '<img src="' + esc(img) + '" alt="" loading="lazy" width="' + width + '" height="' + Math.round(width * 9 / 16) + '">' +
      '</a>' +
      '<div class="wa-card__body">' +
        '<a class="wa-card__title" href="' + esc(href) + '">' + esc(title) + '</a>' +
        '<div class="wa-card__price-row">' + priceHTML + action + '</div>' +
      '</div>' +
    '</div>';
  }

  /* ---- Build the grid from the table instant_search.js just rendered ----- */
  function render() {
    var old = container.querySelector('.wa-mgrid');
    if (old) old.parentNode.removeChild(old);

    var results = window.search && window.search.helper && window.search.helper.lastResults;
    var hits = (results && results.hits) || [];
    var countEl = document.querySelector('.wa-view-count');
    if (countEl && results && typeof results.nbHits === 'number') {
      countEl.textContent = results.nbHits + (results.nbHits === 1 ? ' product' : ' products');
    }
    var hitsByHandle = {};
    hits.forEach(function (h) { if (h && h.handle) hitsByHandle[h.handle] = h; });

    // One product per row on every collection, grouped or not.
    var large = true;
    var html = '';
    var groups = container.querySelectorAll('.coll-pro-cota-tr');

    if (groups.length) {
      groups.forEach(function (group) {
        var rows = group.querySelectorAll('.coll-pro-ta-tr');
        if (!rows.length) return;
        var heading = group.querySelector('.group-heading');
        var groupImg = group.querySelector('.pro-image-cota');
        html += '<section class="wa-mgroup">';
        if (heading || groupImg) {
          html += '<div class="wa-mgroup__head">' +
            (groupImg ? groupImg.outerHTML : '') +
            (heading ? '<h2 class="group-heading pro-title-cota re-le-sp-2 h-m-tb">' + esc(heading.textContent.trim()) + '</h2>' : '') +
          '</div>';
        }
        html += '<div class="wa-mgrid__cards' + (large ? ' wa-mgrid__cards--large' : '') + '">';
        rows.forEach(function (row) { html += cardHTML(row, hitsByHandle, large); });
        html += '</div></section>';
      });
    } else {
      var rows = container.querySelectorAll('.coll-pro-ta-tr');
      if (rows.length) {
        html += '<div class="wa-mgrid__cards wa-mgrid__cards--large">';
        rows.forEach(function (row) { html += cardHTML(row, hitsByHandle, large); });
        html += '</div>';
      }
    }

    if (!html) return;
    var wrap = document.createElement('div');
    wrap.className = 'wa-mgrid';
    wrap.innerHTML = html;
    container.appendChild(wrap);
  }

  /* ---- Hook into InstantSearch once instant_search.js has created it ----- */
  var tries = 0;
  function hook() {
    var s = window.search;
    if (!(s && typeof s.on === 'function')) {
      if (tries++ < 200) setTimeout(hook, 50);
      return;
    }
    s.on('render', render);
    if (s.helper && s.helper.lastResults) render();
  }
  hook();
})();
